// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2aPZk","vLegacy":"SelectSecondary_vLegacy__6nlpS","error":"SelectSecondary_error__23H2U","disabled":"SelectSecondary_disabled__1721v"};